import { DEFAULT_HEADER, HEADER_SCHEMA, IHeader } from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { IGetGateway, ISaveGateway } from '../gateways';

export class HeaderGateway
  implements
    IGetGateway<null, IApiResponse<IHeader>>,
    ISaveGateway<IHeader, IApiResponse<IHeader>>
{
  private readonly restCallBuilder: RestCallBuilder<IHeader> =
    new RestCallBuilder<IHeader>(DEFAULT_HEADER);

  get(): Observable<IApiResponse<IHeader>> {
    return this.restCallBuilder
      .get('/header/')
      .validate(API_RESPONSE_SCHEMA(HEADER_SCHEMA), 'Header.get')
      .handleMessages()
      .build();
  }

  save(query: IHeader): Observable<IApiResponse<IHeader>> {
    return this.restCallBuilder
      .post('/header/', query)
      .validate(API_RESPONSE_SCHEMA(HEADER_SCHEMA), 'Header.save')
      .handleMessages()
      .build();
  }
}
